module.exports = __webpack_public_path__ + "static/media/Thumbnail3.4f1d323f.png";